<template>
  <div class="animated fadeIn">
    <b-card>
      <div slot="header">
        <b-button :to="{name: 'vote-list', params: {oversea: !!JSON.parse($route.query.oversea)}}" size="sm" variant="link"><i class="fa fa-chevron-left" /></b-button>
        <strong>{{ funcType }}</strong> 实例{{ !!JSON.parse($route.query.oversea) ? overseaTag : '' }}
      </div>
      <b-form @submit="onSubmit" @reset="onReset">
        <b-form-group label="实例标题" label-for="app_name" label-class="font-weight-bold">
          <b-form-input id="app_name" type="text" v-model.trim="data.app_name" required />
        </b-form-group>
        <b-form-group label="登录方式（可多选，不选任意一项视为无需登录，勾选外部登录后由接入方提供登录签名）" label-class="font-weight-bold">
          <b-form-radio-group
            id="radio-group-2"
            v-model="data.extra_login"
            name="radio-sub-component"
          >
            <template v-for="(item, index) in extraLoginOptions">
              <b-form-radio :key="'extraLogin' + index" :value="item.value">{{ item.text }}</b-form-radio>
            </template>
          </b-form-radio-group>
          <b-form-checkbox-group
            v-show="!data.extra_login"
            v-model="login_way_selected"
            :options="login_way_options"
            name="flavour-1a"
          />
          <b-container fluid style="margin-top: 10px;">
            <b-row v-for="(item, key, idx) in login_conf_options" :key="key" v-if="item.conf.length > 0" v-show="login_way_selected.indexOf(item.login_typ) !== -1" class="login_way_conf" align-v="center">
              <b-col sm="1"><h5><b-badge pill variant="primary">{{ item.text }}配置</b-badge></h5></b-col>
              <b-col v-for="(conf_item, conf_idx) in item.conf" :key="conf_idx" :sm="conf_item.sm">
                <b-input type="text" :placeholder="conf_item.text" v-model="login_conf[item.conf_name][conf_item.conf_key]" :required="login_way_selected.indexOf(item.login_typ) !== -1" />
              </b-col>
            </b-row>
          </b-container>
        </b-form-group>
        <b-form-group label="数据表配置" label-class="font-weight-bold">
          <b-container class="bv-example-row" fluid>
            <b-row>
              <b-col v-for="(cfg_item, idx) in default_table_config" :key="idx">
                <h5>
                  <b-badge pill variant="primary">{{ cfg_item.text }}</b-badge>
                  <b-button v-if="!cfg_item.field && !update" size="sm" variant="link" @click="addTableFiled()"><i class="fa fa-plus" /></b-button>
                </h5>
              </b-col>
            </b-row>
            <b-row v-for="(table_item, item_idx) in data.table_config.fields" :key="item_idx" style="margin-bottom: 5px;">
              <b-col v-for="(field_item, field_idx) in JSON.parse(JSON.stringify(default_table_config))" :key="field_idx">
                <b-form-input v-if="field_item.tag === 'input'" v-model="data.table_config.fields[item_idx][field_item.field]" :placeholder="field_item.default" :disabled="update" :required="field_item.required" />
                <b-form-radio-group
                  v-else-if="field_item.tag === 'radio'"
                  v-model="data.table_config.fields[item_idx][field_item.field]"
                  :options="JSON.parse(JSON.stringify(table_radio_options))"
                  :disabled="update"
                  :required="field_item.required"
                  plain
                />
                <b-form-select v-else-if="field_item.tag === 'select'" v-model="data.table_config.fields[item_idx][field_item.field]" :options="table_select_options[field_item.field]" :disabled="update" :required="field_item.required" />
                <b-button v-else pill :required="field_item.required" variant="link" @click="deleteTableFiled(item_idx)" class="text-danger" v-show="!update"><i class="fa fa-trash-o" /></b-button>
              </b-col>
            </b-row>
            <b-row style="margin-bottom: 5px;" align-v="center">
              <b-col>
                <b-form-group label="唯一索引字段" label-for="unique_key">
                  <b-form-tags
                    input-id="unique_key"
                    placeholder="回车确认"
                    v-model="data.table_config.unique_keys"
                    remove-on-delete
                    tag-variant="primary"
                    :input-attrs="{ 'aria-describedby': 'tags-validation-help-unique' }"
                    :tag-validator="indexValidator"
                    :disabled="update"
                    invalid-tag-text="该字段不存在"
                  />
                  <template #description>
                    <div id="tags-validation-help-unique" style="color: #6c757d !important">
                      若开启拉取投票项，则必填。
                    </div>
                  </template>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row style="margin-bottom: 5px;" align-v="center">
              <b-col>
                <b-form-group label="索引字段" label-for="index_key">
                  <b-form-tags
                    input-id="index_key"
                    placeholder="回车确认"
                    v-model="data.table_config.index"
                    remove-on-delete
                    tag-variant="primary"
                    :input-attrs="{ 'aria-describedby': 'tags-validation-help-index' }"
                    :tag-validator="indexValidator"
                    :disabled="update"
                    invalid-tag-text="该字段不存在"
                  />
                  <template #description>
                    <div id="tags-validation-help-index" style="color: #6c757d !important">
                      联合索引的多个字段使用英文逗号隔开。
                    </div>
                  </template>
                </b-form-group>
              </b-col>
            </b-row>
          </b-container>
        </b-form-group>
        <b-form-group label="投票前强制绑定" label-class="font-weight-bold">
          <b-form-checkbox-group
            v-model="bind_way_selected"
            :options="bind_options"
            name="flavour-1a"
          />
          <b-container fluid style="margin-top: 10px;">
            <b-row v-for="(item, key, idx) in bind_conf_options" :key="key" v-if="item.conf.length > 0" v-show="bind_way_selected.indexOf(item.bind_typ) !== -1" class="bind_way_conf" align-v="center">
              <b-col sm="1"><h5><b-badge pill variant="primary">{{ item.text }}配置</b-badge></h5></b-col>
              <b-col v-for="(conf_item, conf_idx) in item.conf" :key="conf_idx" :sm="conf_item.sm">
                <b-input type="text" :placeholder="conf_item.text" v-model="bind_conf[item.conf_name][conf_item.conf_key]" :required="bind_way_selected.indexOf(item.bind_typ) !== -1" />
              </b-col>
            </b-row>
          </b-container>
        </b-form-group>
        <b-form-group label="是否拉取投票项" label-class="font-weight-bold">
          <b-form-checkbox switch v-model="data.is_pull" @click="data.is_pull = !data.is_pull" required :disabled="update && !data.is_pull && data.table_config.unique_keys.length === 0" />
          <b-collapse id="pull_config_collapse" v-model="data.is_pull" style="margin-top: 10px;">
            <b-card header="拉取配置">
              <template v-for="(item, idx) in table_pull_config_params">
                <b-form-group
                  :key="idx"
                  :label="item.text"
                  :label-for="item.field"
                  :description="item.description"
                >
                  <b-form-input v-if="item.tag === 'input'" :key="idx" v-model="data.pull_config[item.field]" :placeholder="item.placeholder" :id="item.field" :type="item.type" :required="data.is_pull && item.required" />
                  <b-form-input v-else-if="item.tag === 'input_external'" :key="idx" v-model="$data[item.field]" :placeholder="item.placeholder" :id="item.field" :type="item.type" :required="data.is_pull && item.required" />
                  <b-form-select v-else-if="item.tag === 'select'" :key="idx" v-model="data.pull_config[item.field]" :options="table_pull_config_select_options[item.field]" :id="item.field" :required="data.is_pull && item.required" />
                  <b-form-select v-else-if="item.tag === 'select_external'" :key="idx" v-model="$data[item.field]" :options="table_pull_config_select_options[item.field]" :id="item.field" :required="data.is_pull && item.required" />
                  <b-form-checkbox v-else-if="item.tag === 'judge'" :key="idx" switch v-model="data.pull_config[item.field]" @click="data.pull_config[item.field] = !data.pull_config[item.field]" :required="data.is_pull && item.required" />
                  <template v-else-if="item.tag === 'dynamic'">
                    <b-container class="bv-example-row" fluid>
                      <b-row>
                        <b-col v-for="(item, idx) in table_pull_config_params_set" :key="idx">
                          <h5>
                            <b-badge pill variant="primary">{{ item.text }}</b-badge>
                            <b-button v-if="!item.field" size="sm" variant="link" @click="addParamSetFiled()"><i class="fa fa-plus" /></b-button>
                          </h5>
                        </b-col>
                      </b-row>
                      <b-row v-for="(param_item, item_idx) in tmp_param_set" :key="item_idx" style="margin-bottom: 5px;">
                        <b-col v-for="(item, idx) in JSON.parse(JSON.stringify(table_pull_config_params_set))" :key="idx">
                          <b-form-input v-if="item.tag === 'input'" v-model="tmp_param_set[item_idx][item.field]" />
                          <b-form-checkbox v-else-if="item.tag === 'check'" switch v-model="tmp_param_set[item_idx][item.field]" @click="tmp_param_set[item_idx][item.field] = !tmp_param_set[item_idx][item.field]" />
                          <b-button v-else pill variant="link" @click="deleteParamSetFiled(item_idx)" class="text-danger"><i class="fa fa-trash-o" /></b-button>
                        </b-col>
                      </b-row>
                    </b-container>
                  </template>
                  <template v-else-if="item.tag === 'show_list'">
                    <b-button
                      v-for="(item, idx) in sign_params_idx"
                      :key="idx"
                      disabled
                      variant="primary"
                      style="margin-right: 5px;"
                    >{{ tmp_param_set[item].key }}</b-button>
                  </template>
                </b-form-group>
              </template>
            </b-card>
          </b-collapse>
        </b-form-group>
        <b-form-group label="投票限制" label-class="font-weight-bold">
          <b-card>
            <template v-for="(item, idx) in table_limit_config_params">
              <b-form-group
                :key="idx"
                :label="item.text"
                :label-for="item.field"
                :description="item.description"
              >
                <b-form-input v-if="item.tag === 'input'" :key="idx" v-model="data.limit_config[item.field]" :placeholder="item.placeholder" :id="item.field" :type="item.type" :required="item.required" />
                <b-form-input
                  v-else-if="item.tag === 'condition-input'"
                  :key="idx"
                  v-model="data.limit_config[item.field]"
                  :placeholder="item.placeholder"
                  :id="item.field"
                  :type="item.type"
                  :required="data.limit_config.is_limit.indexOf(item.required) !== -1"
                  :disabled="data.limit_config.is_limit.indexOf(item.required) === -1"
                />
                <b-form-checkbox-group
                  v-else-if="item.tag === 'checkbox'"
                  v-model="data.limit_config[item.field]"
                  :options="limit_config_options[item.field]"
                  name="flavour-1a"
                />
                <b-form-radio-group
                  v-else-if="item.tag === 'condition-radio'"
                  v-model="data.limit_config[item.field]"
                  name="radio-options"
                  :required="data.limit_config.is_limit.indexOf(item.required) !== -1"
                  :disabled="data.limit_config.is_limit.indexOf(item.required) === -1"
                >
                  <template v-for="(option, index) in limit_config_options[item.field]">
                    <b-form-radio :key="index" :value="option.value">
                      {{ option.text }}
                      <b-input-group class="mb-3" v-if="item.field === 'every' && option.value.toString() === '3' && data.limit_config.every && data.limit_config.every.toString() === '3'">
                        刷新时间：
                        <b-form-input
                          v-model="data.limit_config.refresh_time"
                          type="text"
                          placeholder="HH:mm:ss"
                        />
                        <b-input-group-append>
                          <b-form-timepicker
                            v-model="data.limit_config.refresh_time"
                            button-only
                            right
                            show-seconds
                            locale="en"
                          />
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-radio>
                  </template>
                </b-form-radio-group>
                <b-form-checkbox
                  v-else-if="item.tag === 'judge'"
                  switch
                  v-model="data.limit_config[item.field]"
                  @click="data.limit_config[item.field] = !data.limit_config[item.field]"
                />
              </b-form-group>
            </template>
            <b-form-group label="时间限定" description="时间限定是在指定日期时间范围内的限制">
              <b-container fluid>
                <b-row>
                  <b-col>
                    <label>起始日期</label>
                    <b-form-datepicker id="limit_start_date" v-model="limit_start_date" placeholder="起始日期" class="mb-2" required />
                  </b-col>
                  <b-col>
                    <label>结束日期</label>
                    <b-form-datepicker id="limit_end_date" v-model="limit_end_date" :min="limitMinEndTime" placeholder="结束日期" class="mb-2" required />
                  </b-col>
                </b-row>
                <b-row>
                  <b-col>
                    <label>开始时间</label>
                    <b-input-group class="mb-3">
                      <b-form-input
                        v-model="limit_start_time"
                        type="text"
                        placeholder="HH:mm:ss"
                        required
                      />
                      <b-input-group-append>
                        <b-form-timepicker
                          v-model="limit_start_time"
                          button-only
                          right
                          show-seconds
                          locale="en"
                        />
                      </b-input-group-append>
                    </b-input-group>
                  </b-col>
                  <b-col>
                    <label>结束时间</label>
                    <b-input-group class="mb-3">
                      <b-form-input
                        v-model="limit_end_time"
                        type="text"
                        placeholder="HH:mm:ss"
                        required
                      />
                      <b-input-group-append>
                        <b-form-timepicker
                          v-model="limit_end_time"
                          button-only
                          right
                          show-seconds
                          locale="en"
                        />
                      </b-input-group-append>
                    </b-input-group>
                  </b-col>
                </b-row>
              </b-container>
            </b-form-group>
          </b-card>
        </b-form-group>
        <b-form-group label="易盾配置" label-class="font-weight-bold">
          <b-card>
            <template v-for="(item, idx) in yidun_config_params">
              <b-form-group
                :key="idx"
                :label="item.text"
                :label-for="item.field"
                :description="item.description"
              >
                <b-form-input :key="idx" v-model="data.yidun_config[item.field]" :placeholder="item.placeholder" :id="item.field" :type="item.type" :required="data.is_pull && item.required" />
              </b-form-group>
            </template>
          </b-card>
        </b-form-group>
        <b-form-group label="实例开始时间" label-for="ins_start_time">
          <b-form-input
            id="ins_start_time"
            v-model="data.ins_start_time"
            type="text"
            placeholder="%Y-%m-%d %H:%M:%s"
            required
          />
        </b-form-group>
        <b-form-group label="实例结束时间" label-for="ins_end_time">
          <b-form-input
            id="ins_end_time"
            v-model="data.ins_end_time"
            type="text"
            placeholder="%Y-%m-%d %H:%M:%s"
            required
          />
        </b-form-group>
        <div slot="footer">
          <b-button type="submit" size="sm" variant="outline-primary"><i class="fa fa-check" /> 提交</b-button>
          <b-button type="reset" size="sm" variant="outline-danger"><i class="fa fa-repeat" /> 复位</b-button>
        </div>
      </b-form>
    </b-card>
  </div>
</template>

<script>
import Error from '@/mixin/error'
import consts from '@/utils/consts'

export default {
  name: 'vote-form',
  mixins: [Error],
  props: ['formData', 'func', 'isUpdate'],
  data () {
    return {
      data: this.formData,
      funcType: this.func,
      update: this.isUpdate,
      staticData: JSON.parse(JSON.stringify(this.formData)),
      default_table_config: consts.VOTE_DEFAULT_TABLE_CONFIG,
      table_radio_options: consts.VOTE_RADIO_JUDGE_OPTIONS,
      table_pull_config_params: consts.VOTE_PULL_CONFIG_PARAMS,
      table_pull_config_select_options: consts.VOTE_PULL_CONFIG_SELECT_OPTIONS,
      table_pull_config_params_set: consts.VOTE_PULL_CONFIG_PARAMS_SET,
      tmp_param_set: [JSON.parse(JSON.stringify(consts.VOTE_DEFAULT_PULL_CONFIG_PARAMS_SET_VAL))],
      yidun_config_params: consts.VOTE_YIDUN_CONFIG_PARAMS,
      sign_params_idx: [],
      pull_config_limit_config_id_page: '',
      pull_config_limit_config_id_par_name: '',
      pull_config_limit_config_start: '',
      pull_config_limit_config_end: '',
      pull_config_limit_config_per_num: '',
      pull_config_limit_config_per_num_par_name: '',
      table_limit_config_params: consts.VOTE_LIMIT_CONFIG_PARAMS,
      limit_config_options: consts.VOTE_LIMIT_CONFIG_OPTIONS,
      login_way_selected: [],
      login_way_options: consts.VOTE_LOGIN_CONFIG_OPTIONS,
      login_conf_options: consts.VOTE_DETAIL_LOGIN_CONF,
      login_conf: {
        login_mobile_config: { PRODUCT: '', COST_GATEWAY: '', MSG: '' },
        login_wx_config: { weixin_id: '', weixin_secret: '' },
        login_weibo_config: { weibo_id: '', weibo_secret: '' },
        login_qq_config: { qq_id: '', qq_secret: '' },
        login_wx_mp_config: { weixin_mp_id: '', weixin_mp_secret: '' },
        login_qq_mp_config: { qq_mp_id: '', qq_mp_secret: '' },
        login_facebook_config: { facebook_id: '', facebook_secret: '' },
        login_twitter_config: { twitter_key: '', twitter_secret: '' },
        login_line_config: { line_app_id: '', line_app_secret: '' }
      },
      bind_way_selected: [],
      bind_options: consts.VOTE_BIND_CONFIG_OPTIONS,
      bind_conf_options: consts.VOTE_DETAIL_BIND_CONF,
      bind_conf: {
        phone: { PRODUCT: '', COST_GATEWAY: '', MSG: '' }
      },
      enable_edit_fields: consts.VOTE_ENABLE_EDIT_FIELDS,
      table_select_options: consts.VOTE_TABLE_SELECT_OPTIONS,
      limit_start_date: '',
      limit_end_date: '',
      limit_start_time: '00:00:00',
      limit_end_time: '23:59:59',
      limitMinEndTime: '',
      overseaTag: consts.overseaTag,
      extraLoginOptions: [
        { text: '使用内部登录', value: 0 },
        { text: '使用外部登录', value: 1 }
      ]
    }
  },
  created () {
    this.handleOverseaOptions()
    if (this.update) {
      this.handleUpdateData()
    }
  },
  watch: {
    login_way_selected: function () {
      let total = 0
      Object.entries(this.login_way_selected).forEach((item) => {
        total += Number(item[1])
      })
      this.data.login_conf = {
        is_login_need: this.login_way_selected.length > 0,
        login_way: total
      }
    },
    bind_way_selected: function () {
      let total = 0
      Object.entries(this.bind_way_selected).forEach((item) => {
        total += Number(item[1])
      })
      this.data.bind_config = {
        is_bind_need: this.bind_way_selected.length > 0,
        bind_way: total
      }
    },
    tmp_param_set: {
      handler (newValue, oldValue) {
        this.tmp_param_set.forEach((item, idx, array) => {
          if (this.sign_params_idx.indexOf(idx) !== -1 && (!item.check || !item.key)) {
            this.sign_params_idx.splice(this.sign_params_idx.indexOf(idx), 1)
            item.check = false
          }
          if (this.sign_params_idx.indexOf(idx) === -1 && item.key && item.check) {
            this.sign_params_idx.push(idx)
          }
        })
      },
      deep: true
    },
    limit_start_date: function () {
      this.limitMinEndTime = this.limit_start_date
      if (this.limit_start_date > this.limit_end_date) {
        this.limit_end_date = ''
      }
    }
  },
  methods: {
    onSubmit (evt) {
      evt.preventDefault()
      let data = this.handleData()
      if (!data) {
        return false
      }
      if (!this.update) {
        let res = this.judgeTableField(data.table_config.fields)
        if (!res.flag) {
          return false
        }
        data.table_config.fields = res.data
      }
      if (!this.update && !this.judgeTableIndex(data)) {
        return false
      }
      if (data.pull_config) {
        let res = this.handleParamSet(data)
        if (!res.flag) {
          return false
        }
        data = res.data
      }
      if (this.data.limit_config.is_limit.indexOf(1) !== -1 && this.data.limit_config.user_limit_num) {
        if (Number(this.data.limit_config.user_limit_num) > Number(this.data.limit_config.limit_vote_num)) {
          this.$message.error('单位时间投票数 不可大于 总投票数')
          return false
        }
      }
      if (this.update) {
        this.$emit('submitData', this.judgeUpdateData(data))
      } else {
        this.$emit('submitData', data)
      }
    },
    onReset (evt) {
      evt.preventDefault()
      this.data = JSON.parse(JSON.stringify(this.staticData))
      this.login_way_selected = []
      this.sign_params_idx = []
      this.login_conf.login_mobile_config = !(this.update && this.staticData.login_conf.mobile) ? { PRODUCT: '', COST_GATEWAY: '', MSG: '' } : this.staticData.login_conf.mobile
      this.login_conf.login_wx_config = !(this.update && this.staticData.login_conf.weixin) ? { weixin_id: '', weixin_secret: '' } : this.staticData.login_conf.weixin
      this.login_conf.login_weibo_config = !(this.update && this.staticData.login_conf.weibo) ? { weibo_id: '', weibo_secret: '' } : this.staticData.login_conf.weibo
      this.login_conf.login_qq_config = !(this.update && this.staticData.login_conf.qq) ? { qq_id: '', qq_secret: '' } : this.staticData.login_conf.qq
      this.login_conf.login_wx_mp_config = !(this.update && this.staticData.login_conf.weixin_mp) ? { wx_mp_id: '', wx_mp_secret: '' } : this.staticData.login_conf.weixin_mp
      this.login_conf.login_qq_mp_config = !(this.update && this.staticData.login_conf.qq_mp) ? { qq_mp_id: '', qq_mp_secret: '' } : this.staticData.login_conf.qq_mp
      this.login_conf.login_facebook_config = !(this.update && this.staticData.login_conf.facebook) ? { facebook_id: '', facebook_secret: '' } : this.staticData.login_conf.facebook
      this.login_conf.login_twitter_config = !(this.update && this.staticData.login_conf.twitter) ? { twitter_key: '', twitter_secret: '' } : this.staticData.login_conf.twitter
      this.login_conf.login_line_config = !(this.update && this.staticData.login_conf.line) ? { line_app_id: '', line_app_secret: '' } : this.staticData.login_conf.line

      this.bind_conf.phone = !(this.update && this.staticData.bind_config.phone) ? { PRODUCT: '', COST_GATEWAY: '', MSG: '' } : this.staticData.bind_config.phone
      this.limit_start_date = ''
      this.limit_end_date = ''
      this.limit_start_time = '00:00:00'
      this.limit_end_time = '23:59:59'
      this.limitMinEndTime = ''
      if (this.update) {
        this.handleUpdateData()
      }
    },
    handleOverseaOptions () {
      for (let idx in this.login_way_options) {
        let item = this.login_way_options[idx]
        if (this.$route.query.oversea) {
          item['disabled'] = false
        } else {
          if (item.oversea) {
            item['disabled'] = true
          } else {
            item['disabled'] = false
          }
        }
      }
      for (let idx in this.bind_options) {
        if (this.$route.query.oversea) {
          this.bind_options[idx].disabled = true
        }
      }
    },
    addTableFiled () {
      this.data.table_config.fields.push(JSON.parse(JSON.stringify(consts.VOTE_DEFAULT_TABLE_CONFIG_VAL)))
    },
    deleteTableFiled (idx) {
      this.data.table_config.fields.splice(idx, 1)
    },
    singleIndexValidator (tag) {
      let flag = false
      this.data.table_config.fields.forEach((field) => {
        if (field.field === tag) {
          flag = true
        }
      })
      return flag
    },
    indexValidator (tag) {
      if (tag.indexOf(',') !== -1) {
        for (let idx in tag.split(',')) {
          let flag = this.singleIndexValidator(tag.split(',')[idx])
          if (!flag) {
            return false
          }
        }
        return true
      } else {
        return this.singleIndexValidator(tag)
      }
    },
    addParamSetFiled () {
      this.tmp_param_set.push(JSON.parse(JSON.stringify(consts.VOTE_DEFAULT_PULL_CONFIG_PARAMS_SET_VAL)))
    },
    deleteParamSetFiled (idx) {
      if (this.sign_params_idx.indexOf(idx) !== -1) {
        this.sign_params_idx.splice(this.sign_params_idx.indexOf(idx), 1)
      }
      this.tmp_param_set.splice(idx, 1)
    },
    resetIsLimit () {
      let isLimitList = []
      let isLimit = this.data.limit_config.is_limit
      while (1) {
        if (isLimit <= 0) {
          break
        }
        if (isLimit >= 2) {
          isLimitList.push(2)
          isLimit -= 2
        } else if (isLimit >= 1) {
          isLimitList.push(1)
          isLimit -= 1
        }
      }
      this.data.limit_config.is_limit = isLimitList
    },
    resetLoginWay () {
      let loginWay = Number(this.data.login_conf.login_way)
      while (1) {
        if (loginWay <= 1) {
          break
        }
        if (loginWay >= 2048) {
          if (this.data.login_conf.line) {
            this.login_conf.login_line_config = this.data.login_conf.line
          }
          this.login_way_selected.push(2048)
          loginWay -= 2048
        } else if (loginWay >= 1024) {
          if (this.data.login_conf.twitter) {
            this.login_conf.login_twitter_config = this.data.login_conf.twitter
          }
          this.login_way_selected.push(1024)
          loginWay -= 1024
        } else if (loginWay >= 512) {
          if (this.data.login_conf.facebook) {
            this.login_conf.login_facebook_config = this.data.login_conf.facebook
          }
          this.login_way_selected.push(512)
          loginWay -= 512
        } else if (loginWay >= 256) {
          if (this.data.login_conf.qq_mp) {
            this.login_conf.login_qq_mp_config = this.data.login_conf.qq_mp
          }
          this.login_way_selected.push(256)
          loginWay -= 256
        } else if (loginWay >= 128) {
          if (this.data.login_conf.weixin_mp) {
            this.login_conf.login_wx_mp_config = this.data.login_conf.weixin_mp
          }
          this.login_way_selected.push(128)
          loginWay -= 128
        } else if (loginWay >= 64) {
          if (this.data.login_conf.qq) {
            this.login_conf.login_qq_config = this.data.login_conf.qq
          }
          this.login_way_selected.push(64)
          loginWay -= 64
        } else if (loginWay >= 32) {
          if (this.data.login_conf.weibo) {
            this.login_conf.login_weibo_config = this.data.login_conf.weibo
          }
          this.login_way_selected.push(32)
          loginWay -= 32
        } else if (loginWay >= 16) {
          if (this.data.login_conf.weixin) {
            this.login_conf.login_wx_config = this.data.login_conf.weixin
          }
          this.login_way_selected.push(16)
          loginWay -= 16
        } else if (loginWay >= 4) {
          if (this.data.login_conf.mobile) {
            this.login_conf.login_mobile_config = this.data.login_conf.mobile
          }
          this.login_way_selected.push(4)
          loginWay -= 4
        } else if (loginWay >= 2) {
          this.login_way_selected.push(2)
          loginWay -= 2
        }
      }
    },
    resetBindWay () {
      let bindWay = Number(this.data.bind_config.bind_way)
      while (1) {
        if (bindWay <= 1) {
          break
        }
        if (bindWay >= 2) {
          if (this.data.bind_config.phone) {
            this.bind_conf.phone = this.data.bind_config.phone
          }
          this.bind_way_selected.push(2)
          bindWay -= 2
        }
      }
    },
    resetTableConfig () {
      let tmpTableConfig = null
      for (let key in this.data.table_config) {
        if (key.indexOf('list') !== -1) {
          tmpTableConfig = this.data.table_config[key]
          break
        }
      }
      if (tmpTableConfig) {
        tmpTableConfig.index.forEach((item, idx, array) => {
          array[idx] = item.join(',')
        })
        tmpTableConfig.unique_keys.forEach((item, idx, array) => {
          array[idx] = item.join(',')
        })
        this.data.table_config = tmpTableConfig
      }
    },
    resetParamSet () {
      let tmpParamSet = []
      for (let key in this.staticData.pull_config.param_set) {
        tmpParamSet.push({
          key: key,
          value: this.staticData.pull_config.param_set[key],
          check: this.staticData.pull_config.sign_params.indexOf(key) !== -1
        })
      }
      this.tmp_param_set = tmpParamSet
    },
    resetPullConfigLimitConfig () {
      this.pull_config_limit_config_id_page = !this.update && this.staticData.pull_config.limit_config ? '' : this.staticData.pull_config.limit_config.id_page
      this.pull_config_limit_config_id_par_name = !this.update ? '' : this.staticData.pull_config.limit_config.id_par_name
      this.pull_config_limit_config_start = !this.update ? '' : this.staticData.pull_config.limit_config.start
      this.pull_config_limit_config_end = !this.update ? '' : this.staticData.pull_config.limit_config.end
      this.pull_config_limit_config_per_num = !this.update ? '' : this.staticData.pull_config.limit_config.per_num
      this.pull_config_limit_config_per_num_par_name = !this.update ? '' : this.staticData.pull_config.limit_config.per_num_par_name
    },
    resetLimitConfig () {
      let startInfo = this.staticData.limit_config.limit_start_time.split('-')
      this.limit_start_date = startInfo.slice(0, 3).join('-')
      this.limit_start_time = startInfo.slice(3).join(':')
      let endInfo = this.staticData.limit_config.limit_end_time.split('-')
      this.limit_end_date = endInfo.slice(0, 3).join('-')
      this.limit_end_time = endInfo.slice(3).join(':')
    },
    resetYidunConfig () {
      if (this.staticData.yidun_config) {
        this.data.yidun_config = JSON.parse(JSON.stringify(this.staticData.yidun_config))
      } else {
        this.data.yidun_config = {
          businessId: '',
          secretId: '',
          secretKey: ''
        }
      }
    },
    handleUpdateData () {
      this.data.is_pull = !!this.data.is_pull
      this.resetIsLimit()
      this.resetLoginWay()
      this.resetTableConfig()
      this.resetParamSet()
      this.resetPullConfigLimitConfig()
      this.resetLimitConfig()
      this.resetYidunConfig()
      this.resetBindWay()
    },
    handleData () {
      let newData = JSON.parse(JSON.stringify(this.data))
      if (this.login_way_selected.indexOf(4) !== -1) {
        newData.login_conf.mobile = this.login_conf.login_mobile_config
      }
      if (this.login_way_selected.indexOf(16) !== -1) {
        newData.login_conf.weixin = this.login_conf.login_wx_config
      }
      if (this.login_way_selected.indexOf(32) !== -1) {
        newData.login_conf.weibo = this.login_conf.login_weibo_config
      }
      if (this.login_way_selected.indexOf(64) !== -1) {
        newData.login_conf.qq = this.login_conf.login_qq_config
      }
      if (this.login_way_selected.indexOf(128) !== -1) {
        newData.login_conf.weixin_mp = this.login_conf.login_wx_mp_config
      }
      if (this.login_way_selected.indexOf(256) !== -1) {
        newData.login_conf.qq_mp = this.login_conf.login_qq_mp_config
      }
      if (this.login_way_selected.indexOf(512) !== -1) {
        newData.login_conf.facebook = this.login_conf.login_facebook_config
      }
      if (this.login_way_selected.indexOf(1024) !== -1) {
        newData.login_conf.twitter = this.login_conf.login_twitter_config
      }
      if (this.login_way_selected.indexOf(2048) !== -1) {
        newData.login_conf.line = this.login_conf.login_line_config
      }

      if (this.bind_way_selected.indexOf(2) !== -1) {
        newData.bind_config.phone = this.bind_conf.phone
      }
      if (!this.update) {
        newData.table_config.unique_keys.forEach((item, index, arr) => {
          arr[index] = item.split(',')
        })
        newData.table_config.index.forEach((item, index, arr) => {
          arr[index] = item.split(',')
        })
        newData.table_config.fields.forEach((item, index, arr) => {
          if (!item.default) {
            delete arr[index].default
          }
        })
      }
      if (!newData.is_pull && newData.is_pull !== false && newData.is_pull !== 0) {
        newData.is_pull = false
      }
      if (newData.is_pull) {
        newData.pull_config.sign_params = []
        this.sign_params_idx.forEach((item) => {
          newData.pull_config.sign_params.push(this.tmp_param_set[item].key)
        })
        newData.pull_config.param_set = {}
        for (let idx in this.tmp_param_set) {
          let item = this.tmp_param_set[idx]
          if (newData.pull_config.param_set.hasOwnProperty(item.key)) {
            this.$message.error('拉取传参出现重复字段')
            return false
          }
          newData.pull_config.param_set[item.key] = item.value
        }
        if (!newData.pull_config.is_hmac) {
          newData.pull_config.is_hmac = false
        }
        newData.pull_config.limit_config.id_page = this.pull_config_limit_config_id_page
        newData.pull_config.limit_config.id_par_name = this.pull_config_limit_config_id_par_name
        newData.pull_config.limit_config.start = this.pull_config_limit_config_start
        newData.pull_config.limit_config.end = this.pull_config_limit_config_end
        newData.pull_config.limit_config.per_num = this.pull_config_limit_config_per_num
        newData.pull_config.limit_config.per_num_par_name = this.pull_config_limit_config_per_num_par_name
      } else {
        if ('pull_config' in newData) {
          delete newData.pull_config
        }
      }
      if (newData.pull_config && !newData.pull_config.fetch_ret_lambda) {
        delete newData.pull_config.fetch_ret_lambda
      }
      let isLimitTotal = 0
      if (newData.limit_config.is_limit.indexOf(1) === -1) {
        newData.limit_config.every = null
        newData.limit_config.user_limit_num = null
      }
      if (newData.limit_config.is_limit.indexOf(2) === -1) {
        newData.limit_config.IP_limit_time = null
        newData.limit_config.IP_limit_num = null
      }
      Object.entries(newData.limit_config.is_limit).forEach((item) => {
        isLimitTotal += Number(item[1])
      })
      newData.limit_config.is_limit = isLimitTotal
      newData.limit_config.limit_start_time = this.limit_start_date + '-' + this.limit_start_time.split(':').join('-')
      newData.limit_config.limit_end_time = this.limit_end_date + '-' + this.limit_end_time.split(':').join('-')
      if (isLimitTotal & 1) {
        if (!Number(newData.limit_config.user_limit_num)) {
          this.$message.error('单位时间内用户投票次数不可为0')
          return false
        }
        if (!Number(newData.limit_config.user_item_limit_num)) {
          this.$message.error('单位时间内用户对投票项的投票次数不可为0')
          return false
        }
      }

      if ((newData.yidun_config.businessId || newData.yidun_config.secretId || newData.yidun_config.secretKey) && !(newData.yidun_config.businessId && newData.yidun_config.secretId && newData.yidun_config.secretKey)) {
        this.$message.error('易盾配置填写不完整')
        return false
      }
      if (!(newData.yidun_config.businessId || newData.yidun_config.secretId || newData.yidun_config.secretKey)) {
        newData.yidun_config = {}
      }
      if (newData.limit_config.every.toString() !== '3') {
        newData.limit_config.refresh_time = ''
      }

      return newData
    },
    judgeUpdateData (data) {
      let updatedData = {
        app_id: data.app_id
      }
      this.enable_edit_fields.forEach((field) => {
        if (JSON.stringify(data[field]) !== JSON.stringify(this.staticData[field])) {
          updatedData[field] = data[field]
        }
      })
      return updatedData
    },
    judgeTableField (data) {
      for (let idx in data) {
        let item = data[idx]
        if ((!item.field && item.type) || (item.field && !item.type)) {
          this.$message.error('数据表字段填写不完整')
          return {
            flag: false,
            data: null
          }
        }
        if (item.field.indexOf('option_') !== -1) {
          if (!item.field.split('option_')[1] || isNaN(item.field.split('option_')[1])) {
            this.$message.error('子选项字段名不规范')
            return {
              flag: false,
              data: null
            }
          }
          item.type = 'int'
          item.default = 0
          item.null = false
        }
      }
      for (let idx in data) {
        let fieldList = data.map(i => i.field)
        if (Number(fieldList.indexOf(data[idx].field)) !== Number(idx)) {
          this.$message.error('数据表出现重复字段')
          return {
            flag: false,
            data: null
          }
        }
      }
      for (let idx in data) {
        if (!data[idx].field && !data[idx].type) {
          data.splice(idx, 1)
        } else {
          if (!data[idx].field_len) {
            data[idx].field_len = 10
          }
        }
      }
      return {
        flag: true,
        data: data
      }
    },
    judgeTableIndex (data) {
      let keyList = data.table_config.fields.map(i => i.field)
      for (let idx in data.table_config.unique_keys) {
        let item = data.table_config.unique_keys[idx]
        for (let keyIdx in item) {
          if (keyList.indexOf(item[keyIdx]) === -1) {
            this.$message.error('唯一索引中包含不存在的字段')
            return false
          }
        }
      }
      for (let idx in data.table_config.index) {
        let item = data.table_config.index[idx]
        for (let keyIdx in item) {
          if (keyList.indexOf(item[keyIdx]) === -1) {
            this.$message.error('索引中包含不存在的字段')
            return false
          }
        }
      }
      return true
    },
    handleParamSet (data) {
      for (let key in data.pull_config.param_set) {
        if ((!key && data.pull_config.param_set[key]) || (key && !data.pull_config.param_set[key])) {
          this.$message.error('拉取传参填写不完整')
          return {
            flag: false,
            data: null
          }
        }
      }
      for (let key in data.pull_config.param_set) {
        if (!key && !data.pull_config.param_set[key]) {
          delete data.pull_config.param_set[key]
        }
      }
      return {
        flag: true,
        data: data
      }
    }
  }
}
</script>

<style>
  .card {
    margin-bottom: 0 !important;
  }
  .login_way_conf {
    margin-bottom: 10px;
  }
  .bind_way_conf {
    margin-bottom: 10px;
  }
</style>



// WEBPACK FOOTER //
// VoteForm.vue?7919daa2